import { useSelector } from 'react-redux';
import { Store } from 'redux/store';

export const useLoading = () => {
  const { loading } = useSelector((state: Store) => state.loading);

  return {
    loading,
  };
};
